import { API_URL, API_TOKEN } from "../api/apiConfig";

export const fetchHomecommunitylist = async () => {
  try {
    const response = await fetch(`${API_URL}/hometravelcommunity_list`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    return await response.json();
  } catch (error) {
    console.log("Homecommunitylist API Error:", error);
    return null;
  }
};
